import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import {
  BORDER_OPTIONS,
  BORDER_WIDTH_OPTIONS,
  CORNER_RADIUS_OPTIONS,
  DropdownOption,
  PADDING_OPTIONS,
} from '../../config/extension-ui-options';

@Component({
  selector: 'extension-appearance-style',
  templateUrl: './extension-appearance-style.component.html',
  styleUrls: ['./extension-appearance-style.component.scss'],
  standalone: false,
})
export class ExtensionAppearanceStyleComponent {
  @Input() formGroup: AbstractControl;

  readonly borderOptions: DropdownOption[] = BORDER_OPTIONS;
  readonly borderWidthOptions: DropdownOption[] = BORDER_WIDTH_OPTIONS;
  readonly cornerRadiusOptions: DropdownOption[] = CORNER_RADIUS_OPTIONS;
  readonly paddingOptions: DropdownOption[] = PADDING_OPTIONS;
}
